import { Severity } from '@/api/domains/analyses/types';
import { SeverityColorConfig } from '../types';

export const getSeverityColor = (severity: Severity): SeverityColorConfig => {
  const configs: Record<Severity, SeverityColorConfig> = {
    CRITICAL: { background: '#ffebee', color: '#c62828' },
    HIGH: { background: '#fff3e0', color: '#e65100' },
    MEDIUM: { background: '#e3f2fd', color: '#1565c0' },
    LOW: { background: '#f3e5f5', color: '#6a1b9a' }
  };
  return configs[severity] || { background: '#f5f5f5', color: '#616161' };
};
